import React from 'react';
import { FormGroup, Label } from 'reactstrap';
import { Btn } from 'AbstractElements';
import DropzoneCommon from 'Component/Learning/Common/Upload/Dropzone';
import VideoPlayer from 'Component/Learning/DetailSubMateri/VideoPlayer';

/**
 * VideoMediaSection (presentational)
 * - Preview video pembahasan (jika update + ada link)
 * - Upload video via DropzoneCommon
 * - Delete handler tetap dari parent
 */
export default function VideoMediaSection(props) {
  const {
    isUpdate,
    videoLink,
    onDelete,
    onChangeStatus,
    accept = '.mp4',
    width = 720,
  } = props;

  return (
    <>
      {(isUpdate === true && videoLink) && (
        <FormGroup className="mb-3">
          <Label
            for="validationImage"
            style={{ fontWeight: 'bold', marginBottom: '15px', marginRight: '10px' }}
          >
            Preview Video Pembahasan :
          </Label>

          <Btn attrBtn={{ className: 'btn btn-danger btn-sm', onClick: onDelete }}>
            <i className="fa fa-trash fa-lg"></i>
          </Btn>

          <VideoPlayer link={videoLink} width={width} />
        </FormGroup>
      )}

      <DropzoneCommon
        label={'Video Pembahasan'}
        inputContent={videoLink ? 'video Pembahasan tersedia' : 'Silahkan upload video Pembahasan'}
        handleChangeStatus={onChangeStatus}
        accept={accept}
      />
    </>
  );
}